import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const speech_bubble_group_empty_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({
  iconColor,
  ...rest
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M16.5,12.5 L16.5,18.5 L14.5,18.5 L14.5,20.75 L12.25,18.5
      L7.5,18.5 L7.5,12.5 L16.5,12.5 Z M11.5,4.5 L11.5,9.5 L6.75,9.5 L4.5,11.75 L4.5,9.5
      L3.5,9.5 L3.5,4.5 L11.5,4.5 Z M20.5,5.5 L20.5,9.5 L19.5,9.5 L19.5,11.75 L17.25,9.5
      L14.5,9.5 L14.5,5.5 L20.5,5.5 Z"
      />
    </svg>
  );
};
